import React from 'react';

import { Box, CircularProgress } from '@material-ui/core';
import { MBText } from '@meetbutter/ui';

import styled from 'styled-components';

const Container = styled('div')`
  ${({ absolute }) =>
    absolute &&
    `
    position: absolute;
  left: 0;
  top: 0;
  `}

  width: ${({ width }) => width};
  height: ${({ height }) => height};
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: 800;
  font-size: 25em;
  will-change: transform, opacity;
  text-shadow: 0px 2px 40px #00000020, 0px 2px 5px #00000030;
`;
export const LoadingBasic = ({
  width = '100%',
  height = '100%',
  color = '#000',
  bgcolor = '#fff',
  absolute = false,
  text = '',
}) => {
  return (
    <Container
      initialPose="closed"
      pose="open"
      width={width}
      height={height}
      absolute={absolute}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        width="100%"
        height="100%"
        bgcolor={bgcolor}
        color={color}
      >
        <Box
          position="absolute"
          width="100%"
          height="100%"
          top={0}
          left={0}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          {text ? (
            <Box display="flex" flexDirection="column" alignItems="center">
              <Box mb={2} display="flex">
                <CircularProgress color="inherit" />
              </Box>
              <MBText variant="body2" t={text} />
            </Box>
          ) : (
            <CircularProgress color="inherit" />
          )}
        </Box>
      </Box>
    </Container>
  );
};
